import React from 'react'
import './Spinner.scss'

export default function Spinner() {
    return (
        <div className="fd-Spinner-container">
            <div className="fd-Spinner"/>
        </div>
    )
}
